import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {QrCodeRequest} from '../../models/qr-code-request.model';
import {QrGenerationService} from '../../shared/services/qr-generation.service';
import {QrCodeResponse} from '../../models/qr-code-response';
import {CommonModule} from '@angular/common';
import {AppConstants} from '../../shared/app-constants';

@Component({
  selector: 'app-qr',
  imports: [CommonModule],
  templateUrl: './qr.component.html',
  styleUrl: './qr.component.scss'
})
export class QrComponent implements OnInit, OnChanges {

  constructor(private readonly qrGenerationService: QrGenerationService) {
  }

  @Input() isGenerateQrClicked: boolean = false;
  @Input() payNowAmount?: number;
  @Input() pacNumber ?: string;
  @Output() payNowQrPopupClosed = new EventEmitter<void>();
  qrDetails: QrCodeResponse | null = null;
  pacToShow?: string = '';
  allowDownloads: boolean = false;
  note: string = AppConstants.QR_NOTE;

  ngOnInit(): void {
    const authDataRaw = localStorage.getItem('authData');
    if (authDataRaw) {
        const authData = JSON.parse(authDataRaw);
        this.allowDownloads = authData?.capabilities?.[0]?.allowDownloads === true;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.pacToShow = this.pacNumber?.replace(/^PAC/, '');
    if (changes['isGenerateQrClicked']?.currentValue) {
      this.onGenerateQRCode();
    }
  }

  onGenerateQRCode() {
    const request: QrCodeRequest = {
      amount: this.payNowAmount || 0,
      pacNumber: this.pacNumber || ''
    };

    this.qrGenerationService.generateQR(request).subscribe({
      next: (response: QrCodeResponse) => {
        this.qrDetails = {
          qrCodeBase64String: response.qrCodeBase64String,
          qrExpiryDateTime: response.qrExpiryDateTime,
          amount: response.amount,
          showUenPac: response.showUenPac,
          uen: response.uen
        };
        this.updateQrGenerationAttemptNumberInLocalStorage();
      },
      error: (err) => {
      }
    });
  }

  downloadQrCode() {
    if (!this.qrDetails?.qrCodeBase64String) {
      return;
    }

    const base64Image = this.qrDetails.qrCodeBase64String;
    const link = document.createElement('a');
    link.href = base64Image;
    link.download = `PayNow-QR-${this.pacNumber}.png`;

    document.body.appendChild(link);
    link.click();
    link.remove(); // prefer childnode.remove over parentnode.removechild(childnode)
  }

  onPaynowQRPopupClose() {
    this.payNowQrPopupClosed.emit();
  }

  updateQrGenerationAttemptNumberInLocalStorage() { //handle this exception or docnt catch it at all
    const key = `PAY_NOW_ATTEMPTED`;
      const currentAttempt = Number(localStorage.getItem(key)) || 0;
      const updatedAttempt = currentAttempt + 1;
      localStorage.setItem(key, String(updatedAttempt));
  }

}
